import {
    InvoiceModel,
    InvoiceItemsModel,
    PriceOfferIntervalsGroupByReservationId,
    FiscalGeneralSettings,
    InvoiceBaobabModel,
    PosTerminalModel,
    RoomInfoMap,
    InvoiceModelWithInvoiceItems,
    // UserInfo,
    // PosDisplayConfigModel,
    PosItemModel,
    LoyaltyProgramModel,
} from '@common/modelDefinition';

export enum InvoiceTypeEnum {
    geniue,
    advance,
    proforma,
    proformaDispatched
}

export interface RoomCleaningRequest {
    key: string;
    value: boolean;
}

export interface ReservationTypeBody {
    reservationId: number | null;
    groupUuid: string | null;
    loyaltyEnabled?:boolean

}

export interface ApplyCurrentOffer extends ReservationTypeBody {
    priceOfferIntervals: PriceOfferIntervalsGroupByReservationId;
}

export interface LoadCheckoutInvoice {
    reservationId: number | null;
    groupUuid: string | null;
    location?: any | null;
}

export interface InvoiceAndCloseReservationProps extends InvoiceBaobabModel {
    history?: any;
    location?: any;
    match?: any;
    translate?: any;
    posItems: PosItemModel[];
    PosTerminals: PosTerminalModel[];
    systemLocale: string;
    fiscalGeneralSettings: FiscalGeneralSettings;
    selectedPosTerminalId: number;
}

export interface CheckoutOptionsProps extends InvoiceAndCloseReservationProps {
    showReclamationNote?: boolean;
    setReclamationReason?: Function;
    systemLocale: string;
    children?: any;
    selectedPosTerminalId: number;
    fiscalGeneralSettings: FiscalGeneralSettings;
    invoiceForStorno?: InvoiceModelWithInvoiceItems;
    roomInfoMap?: RoomInfoMap;
    reservationId: number | null;
    groupUuid: string | null;
    //   posDisplayConfigs?: PosDisplayConfigModel[],
    invoiceToSplit?: InvoiceModelWithInvoiceItems | null;
    setInvoiceToSplit?: Function;
    index?: number;
    pendingInvoice?: number;
    id?: number | null | undefined;
    showCustomerAndCompanies?: boolean;
    setShowCustomerAndCompanies?: Function;
    targetLoyaltyProgram?: LoyaltyProgramModel | null;
}

export interface PaymentType {
    name: string;
    icon: any;
    value: string;
}

export interface ConfirmationModalProps {
    title?: string;
    callback?: any;
}

export interface ExchangeRates {
    [key: string]: number;
}

export interface GroupedInvoiceItems {
    [key: string]: InvoiceItemsModel[];
}

export interface CurrentOfferProps {
    invoice: InvoiceModel;
    invoiceItems: InvoiceItemsModel[];
    priceOfferIntervals?: PriceOfferIntervalsGroupByReservationId;
    undo?: boolean;
    translate?: any;
    reservationId: number | null;
    groupUuid: string | null;
}
